export const splitPathName = (pathname) => {
  const re = RegExp(/[a-z0-9]+(?:-[a-z0-9]*)*/g);

  return Array.from(pathname.matchAll(re), (m) => m[0]);
};

export default splitPathName;
